<template>
  <div class="notifications">
    <h2>Bildirim Tercihleri</h2>

    <div class="option">
      <label>
        <input type="checkbox" v-model="emailNotifications" />
        E-posta Bildirimleri
      </label>
    </div>

    <div class="option">
      <label>
        <input type="checkbox" v-model="smsNotifications" />
        SMS Bildirimleri
      </label>
    </div>

    <button class="btn primary" @click="saveNotifications">Kaydet</button>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getToken } from '@/utils/auth'

const emailNotifications = ref(false)
const smsNotifications = ref(false)
const baseURL = process.env.VUE_APP_API_URL

onMounted(async () => {
  const res = await fetch(`${baseURL}/settings/notifications`, {
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  })
  if (res.ok) {
    const data = await res.json()
    emailNotifications.value = !!data.email_notifications
    smsNotifications.value = !!data.sms_notifications
  }
})

async function saveNotifications() {
  const res = await fetch(`${baseURL}/settings/notifications`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      email_notifications: emailNotifications.value,
      sms_notifications: smsNotifications.value
    })
  })

  const data = await res.json()
  if (res.ok) {
    alert(data.message || 'Bildirim ayarları güncellendi.')
  } else {
    alert(data.message || 'Bir hata oluştu.')
  }
}
</script>

<style scoped>
.notifications {
  max-width: 600px;
  margin: auto;
}

.option {
  margin-bottom: 16px;
  font-size: 1em;
}

label {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

input[type='checkbox'] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.btn.primary {
  padding: 10px 20px;
  background-color: #0c2d57;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
</style>
